import { addDays, isSameMonth, isToday } from "date-fns";
import { startDrag, useDrop } from "@/components/calendar/Grid";
import { WEEKDAYS_SHORT, dateKey, fmtRo, monthGridStart, timeOf } from "@/lib/cal";
import { cn } from "@/lib/utils";

const MAX_CHIPS = 3;

const Chip = ({ a, color, onEvent }) => (
  <button
    data-testid={`month-appt-${a.id}`}
    draggable={a.status !== "anulat"}
    onDragStart={(e) => startDrag(e, a)}
    onClick={(e) => { e.stopPropagation(); onEvent(a); }}
    className={cn("flex w-full items-center gap-1 truncate rounded px-1 py-0.5 text-left text-[11px] transition-colors hover:bg-accent",
      a.status !== "anulat" && "cursor-grab", a.status === "anulat" && "line-through opacity-50")}
  >
    <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: color }} />
    <span className="font-mono">{timeOf(a.start)}</span>
    <span className="hidden truncate sm:inline">{a.service_name}</span>
  </button>
);

const Cell = ({ d, month, list, staffById, onEvent, onDayClick, onMove }) => {
  const key = dateKey(d);
  const drop = useDrop(({ id }) => onMove(id, { date: key }));
  return (
    <div {...drop.props} onClick={() => onDayClick(d)} data-testid={`month-cell-${key}`}
      className={cn("min-h-[92px] cursor-pointer border-b border-r p-1 transition-colors hover:bg-accent/40 sm:min-h-[112px] sm:p-1.5",
        !isSameMonth(d, month) && "bg-muted/30 text-muted-foreground", drop.over && "bg-primary/10")}>
      <div className="mb-1 flex justify-end">
        <span className={cn("grid h-6 w-6 place-items-center rounded-full text-xs font-semibold", isToday(d) && "bg-primary text-primary-foreground")}>{fmtRo(d, "d")}</span>
      </div>
      <div className="space-y-0.5">
        {list.slice(0, MAX_CHIPS).map((a) => <Chip key={a.id} a={a} color={staffById[a.staff_id]?.color} onEvent={onEvent} />)}
        {list.length > MAX_CHIPS && <div className="px-1 text-[11px] font-semibold text-primary" data-testid={`month-more-${key}`}>+{list.length - MAX_CHIPS} mai multe</div>}
      </div>
    </div>
  );
};

export const MonthView = ({ month, appts, staffById, onEvent, onDayClick, onMove }) => {
  const start = monthGridStart(month);
  const days = Array.from({ length: 42 }, (_, i) => addDays(start, i));
  const byDay = appts.reduce((m, a) => ({ ...m, [a.start.slice(0, 10)]: [...(m[a.start.slice(0, 10)] || []), a] }), {});
  return (
    <div className="overflow-hidden rounded-xl border bg-card" data-testid="month-view">
      <div className="grid grid-cols-7 border-b">
        {WEEKDAYS_SHORT.map((w) => <div key={w} className="py-2 text-center text-[11px] font-medium uppercase tracking-wider text-muted-foreground">{w}</div>)}
      </div>
      <div className="grid grid-cols-7 [&>*:nth-child(7n)]:border-r-0">
        {days.map((d) => (
          <Cell key={dateKey(d)} d={d} month={month} list={byDay[dateKey(d)] || []} staffById={staffById} onEvent={onEvent} onDayClick={onDayClick} onMove={onMove} />
        ))}
      </div>
    </div>
  );
};
